import React, { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

import Modal from 'components/Modal/Modal';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import {
  getGroupsForTeacherByLesson,
  getStudentsForClass,
  teacherGetGroupsState,
} from 'redux/liveClass/teacherGetGroups.slice';
import { getUser } from 'redux/authentication/auth.slice';
import { ReactComponent as RemoveIcon } from 'assets/icons/trash.svg';
import { teacherCreateGroupState } from 'redux/liveClass/teacherCreateGroups.slice';
import { teacherRemoveGroupBYId } from 'redux/liveClass/teacherRemoveGroup.slice';
import { getHeaderActiveClass } from 'redux/header/selectors';

import CreateGroupModal from './CreateGroupModal';

const Groups: React.FC = () => {
  const { t } = useTranslation('live_classes');
  const dispatch = useAppDispatch();
  const user = useAppSelector(getUser);
  const { model } = useAppSelector(teacherGetGroupsState);
  const { loadingGroupLoading } = useAppSelector(teacherCreateGroupState);
  const activeSubject = useAppSelector(getHeaderActiveClass);
  const [selectedClass, setSelectedClass] = useState(null);
  const [openModal, setOpenModal] = useState(false);

  useState(() => {
    dispatch(getGroupsForTeacherByLesson(user.id));
  });
  // start useEffect

  useEffect(() => {
    if (loadingGroupLoading === 'success') {
      dispatch(getGroupsForTeacherByLesson(user.id));
      setOpenModal(false);
    }
  }, [loadingGroupLoading]);

  useEffect(() => {
    dispatch(getGroupsForTeacherByLesson(user.id));
  }, [activeSubject]);

  useEffect(() => {
    // getStudents for class
    if (selectedClass) {
      dispatch(getStudentsForClass(selectedClass));
    }
  }, [selectedClass]);

  // end useEffect

  // functions
  const handleModal = () => {
    setOpenModal(prevState => !prevState);
  };

  const removeGroup = id => {
    dispatch(teacherRemoveGroupBYId(id));
  };

  return (
    <div>
      <Modal open={openModal} onClose={handleModal}>
        <CreateGroupModal />
      </Modal>
      <div className={'flex justify-between align-center'}>
        <h4> {t('List_of_groups')}</h4>
        <button className={'btn white rounded-full'} onClick={handleModal}>
          {t('Add_group')}
        </button>
      </div>
      <div className={'grid grid-col-3'}>
        {model.map(obj => {
          return (
            <div className="flex mr-1 mt-1" key={obj.id}>
              <label htmlFor={`obj_${obj.id}`} className={'checkbox-square flex'}>
                <input
                  type="checkbox"
                  id={`obj_${obj.id}`}
                  checked={obj.id === selectedClass}
                  value={obj.id}
                  onChange={e => {
                    if (obj.id === selectedClass) {
                      setSelectedClass(null);
                      return;
                    }
                    setSelectedClass(e.target.value);
                  }}
                />
                <span>
                  <section className={'flex btn standard'}>{obj.name}</section>
                </span>
              </label>
              <div className={'flex align-center'}>
                <RemoveIcon className={'pointer'} onClick={() => removeGroup(obj.id)} />
              </div>
            </div>
          );
        })}
      </div>
      <br />
      <br />
      <br />
      <br />
    </div>
  );
};

export default Groups;
